import React, { useState } from 'react';
import { Col, Card, CardBody } from 'reactstrap';
import Rating from 'react-rating';
import HeaderCard from '../../Common/HeaderCard';

const MovieRating = () => {
  const [rating, setRating] = useState(2);
  return (
    <Col xl='6' lg='12' md='6'>
      <Card>
        <HeaderCard title={'Movie Rating'} />
        <CardBody>
          <div className='rating '>
            <Rating stop={4} initialRating={rating} emptySymbol='br-widget' fullSymbol='br-widget br-current' onChange={(rate) => setRating(rate)}></Rating>
            <span className='current-rating'>{rating}</span>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default MovieRating;
